import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { Claims } from '../../constants/claims';
import { UserType } from 'src/models/ts/user-type.model';

export const usertypeGuard: CanActivateFn = (route): boolean | UrlTree => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const allowedUserTypes: UserType[] = route.data['allowedUserTypes'] || [];
  const redirectTo: string | undefined = route.data['redirectTo'];

  if (allowedUserTypes.length === 0) {
    return true;
  }

  const userType = Number(authService.getAccessTokenClaim(Claims.UserType)) as UserType;

  if (allowedUserTypes.includes(userType)) {
    return true;
  }

  return redirectTo ? router.createUrlTree([redirectTo]) : false;
};
